import React from "react";
import { steps_array } from "../utils";

const ProgressBar = ({ page, data }) => {
  let total = data?.register_as === "Complete Registration Online" ? 8 : 2;
  let application_number = window.sessionStorage.getItem("application_number");

  return (
    <header className="steps_header">
      <div className="steps">
        <p>
          {data?.register_as === "Complete Registration Online"
            ? `Step ${(page / total) * 8} of ${steps_array.length}`
            : `Step ${(page / total) * 2} of 2`}
        </p>
        {application_number ? <p>Application No: {application_number}</p> : ""}
      </div>
      <div
        className="progress_bar"
        style={{
          width: ` ${
            data?.register_as === "Complete Registration Online"
              ? steps_array[page - 1].percent
              : (page / total) * 100
          }%`,
        }}
      >
        {data?.register_as === "Complete Registration Online"
          ? steps_array[page - 1].percent
          : (page / total) * 100}
        %
      </div>
    </header>
  );
};

export default ProgressBar;
